import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

/**
 * Global styles for the application
 * These styles complement the Material-UI theme
 */
export const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={{
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      html: {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
        width: '100%',
        overflowX: 'hidden',
      },
      '#root': {
        height: '100%',
        width: '100%',
      },
      a: {
        textDecoration: 'none',
        color: 'inherit',
      },
      'a:hover': {
        textDecoration: 'none',
      },
      img: {
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
      },
      'input:focus, textarea:focus, select:focus': {
        outline: 'none',
      },
      '.main': {
        minHeight: 'calc(100vh - 400px)',
      },
    }}
  />
);
